<template>
  <HKLModal
    ref="modal"
    okBtnAction="send"
    @onCloseClick="cleanModalState"
  >
    <template slot="title">
      <span :class="{ 'required-flag': true }">{{ $t('tenancy.greenOperation.sendReminderHint') }}</span>
      <label>{{ $t('hint.continue') }}</label>
    </template>
    <HKLForm
      ref="form"
      class="check-validation"
    >
      <div class="text-input">
        <textarea
          v-model="reminderComment"
          v-autosize
          v-hkldinput
          v-fusioninputcheck="{
            type: 'string',
            required: true
          }"
          :placeholder="$t('tenantProjects.finalDocuments.sendReminder.placeHolder')"
        />
      </div>
    </HKLForm>
  </HKLModal>
</template>

<script>
import HKLForm from '@/controls/Form/HKLForm'

import HKLModal from '@/controls/Modal/HKLModal'
import { unref, ref, onMounted } from 'vue-demi'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useGreenOperation } from './hook'
import { sendOperationReminder } from '@/api/tenancies/GreenOperation.request'
import { utils as formUtils } from '@/plugin/InputChange'
import { useRefForm } from '@/controls/Form/hook'

export default {
  components: {
    HKLForm,
    HKLModal,
  },
  setup () {
    const forms = useRefForm()
    const modals = useRefModal()
    const { data: greenOperation, refresh } = useGreenOperation()
    const reminderComment = ref('')
    const sendReminder = async () => {
      if (!forms.validate()) return
      await sendOperationReminder(unref(greenOperation).id, { comment: reminderComment.value })
      await refresh()
      cleanModalState()
      modals.close()
    }
    const cleanModalState = () => {
      reminderComment.value = ''
      formUtils.resetDirty()
    }

    onMounted(() => {
      modals.modal.value.onClick = async () => {
        await sendReminder()
      }
    })

    return {
      ...modals,
      ...forms,
      reminderComment,
      sendReminder,
      cleanModalState,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/textField';
</style>
